
// @group components

export default {
  name: 'UsageExampleComponent',
  props: ['data'],
  data() {
    return {
      isHover: false
    }
  },
  methods: {
    hoverEffect() {
      this.isHover = !this.isHover
    }
  }
}
